import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from '@angular/core';
import {
  BehaviorInputData,
  FidelityReviewSection,
  FormEventEmit,
} from '../../../fidelity.interface';
import { CommonModule } from '@angular/common';
import { CorrectionNeededFormComponent } from '../correction-needed-form/correction-needed-form.component';

@Component({
  selector: 'app-correction-needed-strategy',
  standalone: true,
  imports: [CorrectionNeededFormComponent, CommonModule],
  templateUrl: './correction-needed-strategy.component.html',
})
export class CorrectionNeededStrategyComponent implements OnChanges {
  @Input() fidelityData: BehaviorInputData | null = null;
  @Output() formValueChange = new EventEmitter<FormEventEmit>();

  strategyData: FidelityReviewSection | null = null;
  ngOnChanges(): void {
    if (this.fidelityData) {
      this.strategyData = this.fidelityData.fidelityData?.stretagy ?? null;
    }
  }
}
